"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepthChartPosition = void 0;
// eslint-disable-next-line @typescript-eslint/no-namespace
var DepthChartPosition;
(function (DepthChartPosition) {
    /**
     * Enum that defines the specific player position name when on an NFL depth chart.
     */
    let Position;
    (function (Position) {
        /**
         * Defensive Right Tackle.
         */
        Position["DefensiveRightTackle"] = "DRT";
        /**
         * Defensive Left Tackle.
         */
        Position["DefensiveLeftTackle"] = "DLT";
        /**
         * Weak Side Linebacker.
         */
        Position["WeakSideLinebacker"] = "WLB";
        /**
         * Strong Side Linebacker.
         */
        Position["StrongSideLineBacker"] = "SLB";
        /**
         * Right Inside Linebacker.
         */
        Position["RightInsideLinebacker"] = "RILB";
        /**
         * Left Tackle.
         */
        Position["LeftTackle"] = "LT";
        /**
         * Left Guard.
         */
        Position["LeftGuard"] = "LG";
        /**
         * Center.
         */
        Position["Center"] = "C";
        /**
         * Right Guard.
         */
        Position["RightGuard"] = "RG";
        /**
         * Right Tackle.
         */
        Position["RightTackle"] = "RT";
        /**
         * Left Inside Linebacker.
         */
        Position["LeftInsideLinebacker"] = "LILB";
        /**
         * Quarterback.
         */
        Position["Quarterback"] = "QB";
        /**
         * Halfback.
         */
        Position["HalfBack"] = "HB";
        /**
         * Fullback.
         */
        Position["FullBack"] = "FB";
        /**
         * Nose Tackle.
         */
        Position["NoseTackle"] = "NT";
        /**
         * Free Safety.
         */
        Position["FreeSafety"] = "FS";
        /**
         * Strong Safety.
         */
        Position["StrongSafety"] = "SS";
        /**
         * Left Cornerback.
         */
        Position["LeftCornerback"] = "LCB";
        /**
         * Right Cornerback.
         */
        Position["RightCornerback"] = "RCB";
        /**
         * Slot Cornerback.
         */
        Position["SlotCornerback"] = "SCB";
        /**
         * Nickelback.
         */
        Position["Nickelback"] = "NB";
        /**
         * Kicker.
         */
        Position["Kicker"] = "K";
        /**
         * Kick Returner.
         */
        Position["KickerReturner"] = "KR";
        /**
         * Right Outside Linebacker.
         */
        Position["RightOutsideLinebacker"] = "ROLB";
        /**
         * Left Outside Linebacker.
         */
        Position["LeftOutsideLinebacker"] = "LOLB";
        /**
         * Middle Linebacker.
         */
        Position["MiddleLinebacker"] = "MLB";
        /**
         * Punter.
         */
        Position["Punter"] = "P";
        /**
         * Punt Returner.
         */
        Position["PuntReturner"] = "PR";
        /**
         * Long Snapper.
         */
        Position["LongSnapper"] = "LS";
        /**
         * Left Wide Receiver.
         */
        Position["LeftWideReceiver"] = "LWR";
        /**
         * Right Wide Receiver.
         */
        Position["RightWideReceiver"] = "RWR";
        /**
         * Slot Left Wide Receiver.
         */
        Position["SlotLeftWideReceiver"] = "SLWR";
        /**
         * Slot Right Wide Receiver.
         */
        Position["SlotRightWideReceiver"] = "SRWR";
        /**
         * Slot Wide Receiver.
         */
        Position["SlotWideReceiver"] = "SWR";
        /**
         * Left Tight End.
         */
        Position["LeftTightEnd"] = "TE-L";
        /**
         * Right Tight End.
         */
        Position["RightTightEnd"] = "TE-R";
        /**
         * Defensive Left End.
         */
        Position["DefensiveLeftEnd"] = "DLE";
        /**
         * Defensive Right End.
         */
        Position["DefensiveRightEnd"] = "DRE";
        /**
         * Right End.
         */
        Position["RightEnd"] = "RE";
        /**
         * Left End.
         */
        Position["LeftEnd"] = "LE";
    })(Position = DepthChartPosition.Position || (DepthChartPosition.Position = {}));
})(DepthChartPosition || (exports.DepthChartPosition = DepthChartPosition = {}));
//# sourceMappingURL=depth_chart_position.js.map